import { Component } from 'react'
import { Grid, Typography } from '@mui/material'
import Button from '../control/Button'
import SplitBottonControl, { OptionsValue } from '../control/materialUI/SplitBottonControl'

class ButtonPlayground extends Component {
    render() {
        return (
            <Grid container>
                <Grid container>
                    <Typography variant="h3" gutterBottom>
                        Control: Button
                    </Typography>
                </Grid>
                <Grid
                    container
                    style={{
                        marginBottom: '10px',
                    }}
                >
                    <Button
                        color="primary"
                        onClick={() => {
                            console.log('clicked 1')
                        }}
                    >
                        CLICK (primary color)
                    </Button>
                </Grid>
                <Grid
                    container
                    style={{
                        marginBottom: '10px',
                    }}
                >
                    <Button
                        color="secondary"
                        onClick={() => {
                            console.log('clicked 2')
                        }}
                    >
                        CLICK (secondary color)
                    </Button>
                </Grid>
                <Grid container>
                    <Button
                        color="primary"
                        onClick={() => {
                            console.log('clicked 3')
                        }}
                        disabled
                    >
                        CLICK (disabled)
                    </Button>
                </Grid>
                <Grid container sx={{ mt: 1 }}>
                    <SplitBottonControl
                        options={[
                            {
                                value: 'pdf',
                                label: 'ดาวน์โหลดรายงาน (PDF)'
                            },
                            {
                                value: 'excel',
                                label: 'ดาวน์โหลดรายงาน (Excel)'
                            }
                        ]}
                        onClick={(selectedValue: OptionsValue) => console.info(selectedValue)}
                        onMenuItemClick={(selectedValue: OptionsValue) => console.info(selectedValue)}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default ButtonPlayground
